module.exports = __webpack_public_path__ + "img/封装2.9cf21ce8.svg";